//import action types
import service from "../service.js";
import { CREATE_BOARD, UPDATE_BOARD, GET_ALL_BOARDS, DELETE_BOARD, SHARED_BOARD_EMAILS,GET_ALL_CLIENT_BOARDS } from "./types.js";

const boardCreated = (data) => ({
    type: CREATE_BOARD,
    payload: data
})

const boardUpdated = (data) => ({
    type: UPDATE_BOARD,
    payload: data
})

const boardFetched = (data) => ({
    type: GET_ALL_BOARDS,
    payload: data
})

const boardDeleted = (data) => ({
    type: DELETE_BOARD,
    payload: data
})

const sharedBoardEmails = (data) => ({
    type: SHARED_BOARD_EMAILS,
    payload: data
})

export const createBoard = ((data) => async (dispatch) => {

    return await service.createBoard(data)
    .then((response) => {
        if(response.error){
            throw response.error;
        }
        dispatch(boardCreated(response.data))
        return Promise.resolve();
    }).catch(() => {
        return Promise.reject();
    })

})

export const updateBoard = ((data) => async (dispatch) => {

    return await service.updateBoard(data)
    .then((response) => {
        if(response.error){
            throw response.error;
        }
        dispatch(boardUpdated(response.data))
        return Promise.resolve();
    }).catch(() => {
        return Promise.reject();
    })

})

export const getAllBoards = (() => async (dispatch) => {

    return await service.getAllBoards()
    .then((response) => {
        if(response.error){
            throw response.error;
        }
        dispatch(boardFetched(response.data))
        return Promise.resolve();
    }).catch(() => {
        return Promise.reject();
    })

})

export const deleteBoard = ((id) => async (dispatch) => {

    return await service.deleteBoard(id)
    .then((response) => {
        if(response.error){
            throw response.error;
        }
        dispatch(boardDeleted(id))
        return Promise.resolve();
    }).catch(() => {
        return Promise.reject();
    })

})

export const fetchSharedBoardEmails = ((id) => async (dispatch) => {

    return await service.fetchSharedEmails(id)
    .then((response) => {
        if(response.error){
            throw response.error;
        }
        dispatch(sharedBoardEmails(response.data))
        return Promise.resolve(response.data);
    }).catch(() => {
        return Promise.reject();
    })

})